import {headerNames} from '../constants';
import * as snapAuth from '../core/snap-auth';
import {log} from '../shared/log';
import {ui} from '../shared/ui';
import {SnapComponent} from './snap.component';

export async function init() {
  try {
    const signInForm = ui.forms.get(SnapComponent.formName);

    if (signInForm == null) {
      throw new Error(`UI form not found for "${SnapComponent.formName}".`);
    }

    return new SnapComponent(snapAuth, signInForm, ui, log, headerNames.REDIRECT_URL);

  } catch (ex) {
    const message = typeof ex === 'string' ? ex : ex.message;
    log.warn(message);
    log.sendError(message);
    throw new Error(message);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/snap.ts